import type { Element as HastElement, RootContent as HastNode } from "hast";

import type { TExtractedListLinks } from "./types";

/**
 * Recursively extracts all hyperlink URLs contained within a given HAST node subtree.
 *
 * @param initialNode - The root HAST node representing the list subtree.
 * @returns {ExtractedListLinks} An object containing:
 *   - `urls`: Array of URLs found inside this list (not deduplicated)
 *   - `total`: Count of all URLs found
 */
export function extractLinksFromListSubtree(initialNode: HastNode | undefined): TExtractedListLinks {

  if (!initialNode) {
    return {
      urls: [],
      total: 0
    }
  }
  
  const urls: string[] = [];

  const walk = (node: HastNode): void => {
    if (!node || typeof node !== "object") return;

    if ("type" in node && node.type === "element") {
      const element = node as HastElement;

      if (element.tagName === "a") {
        const href = element.properties?.href;
        if (typeof href === "string") {
          urls.push(href);
        }
      }

      if (Array.isArray(element.children)) {
        element.children.forEach(walk);
      }
    }
  };

  walk(initialNode);

  return {
    urls,
    total: urls.length,
  };
}
